import { CARTSTATES, THEME } from 'Assets/js/lib/constants'
import CountdownTimer from 'Assets/js/lib/countdown-timer'
import { updateItemById, addItemById, updateCart } from 'Assets/js/lib/cart'
import Carousel from 'Assets/js/lib/carousel'
;(function () {
  const components = {
    cartLineItemAction: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', async (e) => {
        e.preventDefault()

        const formData = {
          id: node.getAttribute('data-id'),
          quantity: Number(node.getAttribute('data-quantity')),
        }

        const response = await updateItemById(formData)

        if (!response || response.status === 'bad_request') {
          node.disabled = false
          return ctx.emit(CARTSTATES.UPDATINGERROR, null)
        }

        ctx.emit(CARTSTATES.UPDATED, null, { cart: response })
      })
    }),
    cartDrawerUpdate: SAXX.Init.Component((node, ctx) => {
      ctx.on(CARTSTATES.UPDATED, (_, { cart } = { cart: {} }) => {
        node.querySelectorAll('[data-update-section]').forEach((section) => {
          const sectionName = section.getAttribute('data-update-section')
          const cartMarkup = new DOMParser().parseFromString(
            cart?.sections['cart-drawer'],
            'text/html',
          )
          const sectionMarkup = cartMarkup?.querySelector(
            `[data-update-section="${sectionName}"]`,
          )

          if (!sectionMarkup) return

          section.replaceWith(sectionMarkup)
        })

        if (typeof window.Nosto === 'object') {
          Nosto.reloadCart()
        }

        const codeHasErrored = cart?.discount_codes?.filter(
          ({ applicable }) => !applicable,
        ).length

        if (codeHasErrored) {
          node.querySelector('.discount-code-error').innerText =
            'Discount code cannot be applied to your cart'
        }

        SAXX.App.mount()
      })
      ctx.on(CARTSTATES.UPDATINGERROR, (_, { cart } = { cart: {} }) => {
        node.querySelector('[data-error-section]').innerHTML =
          SAXX.Messages.AddToCartError
        setTimeout(() => {
          node.querySelector('[data-error-section]').innerHTML = ''
        }, 3000)
      })
    }),
    cartDrawerStickyFooter: SAXX.Init.Component((node, ctx) => {
      ctx.on(CARTSTATES.UPDATED, (_, { cart } = { cart: {} }) => {
        node.classList.toggle('hidden', cart.item_count === 0)
      })
    }),
    countdownTimer: SAXX.Init.Component((node, ctx) => {
      new CountdownTimer(node, {
        endDate: node.getAttribute('data-end-date'),
        countdownMessage: node.getAttribute('data-countdown-message'),
        fallbackMessage: node.getAttribute('data-fallback-message'),
      })
    }),
    cartDrawerProductCardAction: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('change', async () => {
        const formData = new FormData(node)

        const variantInput = node.querySelector(
          `input[value="${formData.get('id')}"]`,
        )
        formData.append(
          'properties[_ORIGINAL_PRICE]',
          variantInput.getAttribute('data-original-price'),
        )
        if (variantInput.hasAttribute('data-final-sale')) {
          formData.append('properties[_ASRC]', 'Final Sale')
        }

        const response = await addItemById(formData)

        if (!response || response.status === 422) {
          return ctx.emit(CARTSTATES.UPDATINGERROR, null, {
            cart: response,
          })
        }

        ctx.emit(CARTSTATES.UPDATED, null, { cart: response })

        node
          .querySelectorAll('.quick-shop--input')
          .forEach((input) => (input.checked = false))
      })
    }),
    cartGiftWithPurchaseTrigger: SAXX.Init.Component((node, ctx) => {
      ctx.on('gwp:offerUpdate', (_, { offerResults }) => {
        node.classList.toggle('hidden', offerResults.valid.length === 0)
      })

      node.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault()
        ctx.emit(THEME.modalControlInteraction, null, {
          controlElement: 'gift-with-purchase',
        })
      })
    }),
    cartDrawerDiscountForm: SAXX.Init.Component((node, ctx) => {
      const codeInputField = node.querySelector('#cart-drawerDiscountCode')

      codeInputField.addEventListener('focus', () => {
        node.querySelector('.discount-code-error').innerText = ''
      })

      node.addEventListener('submit', async (e) => {
        e.preventDefault()
        const formData = new FormData(node)
        const codes = new Set([formData.get('cart-drawerDiscountCode')])
        formData
          .get('cart-drawerDiscountPreviousCodes')
          .split(',')
          .forEach((code) => codes.add(code))

        const response = await updateCart({
          discount: Array.from(codes).join(','),
        })

        if (!response || response.status === 422) {
          node.querySelector('#cart-drawerDiscountCode').value = ''

          return ctx.emit(CARTSTATES.UPDATINGERROR, null, {
            cart: response,
          })
        }

        ctx.emit(CARTSTATES.UPDATED, null, { cart: response })
      })
    }),
    cartDrawerDiscountRemove: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', async (e) => {
        e.preventDefault()
        const codes = JSON.parse(node.getAttribute('data-updated-discounts'))

        const response = await updateCart({
          discount: Array.from(codes).join(','),
        })

        if (!response || response.status === 422) {
          return ctx.emit(CARTSTATES.UPDATINGERROR, null, {
            cart: response,
          })
        }

        ctx.emit(CARTSTATES.UPDATED, null, { cart: response })
      })
    }),
    cartDrawerProductRecommendations: SAXX.Init.Component((node, ctx) => {
      const fetchRecommendations = (productId = null) => {
        if (!productId) {
          node.classList.add('no-placement')
          return
        }

        const cardTarget = node.querySelector('[data-loading-target]')

        fetch(
          `${window.Shopify.routes.root}recommendations/products?product_id=${productId}&section_id=recommended-products`,
        )
          .then((res) => {
            if (!res.ok) throw new Error(`Fetch error! ${res.status}`)
            return res.text()
          })
          .then((response) => {
            const section = new DOMParser().parseFromString(
              response,
              'text/html',
            )
            cardTarget.innerHTML = section.querySelector(
              '[data-loading-target]',
            ).innerHTML

            const template = node.querySelector('#cart-drawer-recommendations')
            if (template) {
              node
                .querySelector('[data-loading-target]')
                .appendChild(template.content.cloneNode(true))
            }

            new Carousel(
              node.querySelector('.product-recommendations--carousel'),
              { cell: '.product-card' },
            )

            SAXX.App.mount()
            node.classList.remove('no-placement')
          })
          .catch((e) => {
            console.error(e)
            node.classList.add('no-placement')
          })
          .finally(() => {
            node.classList.remove('loading')
          })
      }

      fetchRecommendations(node.getAttribute('data-initial-product-id'))
      ctx.on(CARTSTATES.UPDATED, (_, { cart } = { cart: {} }) => {
        if (cart.items.length === 0) {
          fetchRecommendations(node.getAttribute('data-initial-product-id'))
          return
        }

        const updatededID = cart.items[0].product_id
        if (node.getAttribute('data-product-id') === updatededID) return

        node.setAttribute('data-product-id', updatededID)
        fetchRecommendations(updatededID)
      })
    }),
  }

  Object.assign(SAXX.Init.Components, components)
})()
